<script setup>
import { useGlobalStore } from '@stores/global'
import { useStoreStore } from '@stores/store'
import { ref } from 'vue'

import Button from '@components/global/button.vue'

const links = ref([
	{
		label: 'home',
		to: { name: 'home' },
	},
	{
		label: 'products',
		to: { name: 'products' },
	},
	{
		label: 'merch',
		to: { name: 'merch' },
	},
	{
		label: 'about',
		to: { name: 'about' },
	},
	{
		label: 'blog',
		to: { name: 'blog' },
	},
	{
		label: 'wholesale',
		to: { name: 'wholesale' },
	},
	{
		label: 'contact us',
		to: { name: 'contact' },
	},
])
const store = useStoreStore()
const global = useGlobalStore()

const toggle = (name) => {
	if (global.modal.name === name) {
		global.closeModal()
		return
	}

	global.openModal([name])
}
</script>

<template>
	<header>
		<div class="fixed left-0 right-0 top-0 z-header hidden bg-bgMain lg:flex">
			<div class="grid w-full grid-cols-[2fr_0.5fr_1fr] px-12 py-6 xl:grid-cols-[2fr_1fr_1fr] 2xl:grid-cols-[1fr_auto_1fr]">
				<ul class="flex items-center gap-6 py-3 font-bold capitalize">
					<li v-for="link of links">
						<router-link class="tab relative pb-4 font-medium hover:cursor-pointer" :to="link.to">
							{{ link.label }}
						</router-link>
					</li>
				</ul>
				<router-link :to="{ name: 'home' }">
					<img src="https://d2axlk9d80xmkd.cloudfront.net/gardenmother/images/logo.svg" alt="" />
				</router-link>
				<div class="flex justify-end gap-10">
					<Button label="Product Locator" class="primary" :to="{ name: 'store-locator' }" />
					<div class="flex items-center gap-3">
						<i class="fa-regular fa-circle-user text-[20px]" />
						<div class="relative" @click="global.toggleCart(true)">
							<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path d="M5 1.66797L2.5 5.0013V16.668C2.5 17.11 2.67559 17.5339 2.98816 17.8465C3.30072 18.159 3.72464 18.3346 4.16667 18.3346H15.8333C16.2754 18.3346 16.6993 18.159 17.0118 17.8465C17.3244 17.5339 17.5 17.11 17.5 16.668V5.0013L15 1.66797H5Z" stroke="#15351A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
								<path d="M2.5 5H17.5" stroke="#15351A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
								<path d="M13.3346 8.33203C13.3346 9.21609 12.9834 10.0639 12.3583 10.6891C11.7332 11.3142 10.8854 11.6654 10.0013 11.6654C9.11725 11.6654 8.2694 11.3142 7.64428 10.6891C7.01916 10.0639 6.66797 9.21609 6.66797 8.33203" stroke="#15351A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							</svg>
							<div class="absolute -right-[22px] -top-[22px] rounded-full bg-bgMain p-1">
								<div class="flex h-2 w-2 items-center justify-center rounded-full bg-primary p-3 text-bgMain">
									{{ store.cart?.totalQuantity ?? 0 }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="fixed left-0 top-0 z-header flex w-full justify-between bg-bgMain p-4 lg:hidden">
			<router-link :to="{ name: 'home' }">
				<img src="https://d2axlk9d80xmkd.cloudfront.net/gardenmother/images/logo.svg" alt="" />
			</router-link>

			<div class="flex justify-end gap-10">
				<div class="flex cursor-pointer items-center gap-6">
					<div class="relative" @click="global.toggleCart(true)">
						<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M5 1.66797L2.5 5.0013V16.668C2.5 17.11 2.67559 17.5339 2.98816 17.8465C3.30072 18.159 3.72464 18.3346 4.16667 18.3346H15.8333C16.2754 18.3346 16.6993 18.159 17.0118 17.8465C17.3244 17.5339 17.5 17.11 17.5 16.668V5.0013L15 1.66797H5Z" stroke="#15351A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							<path d="M2.5 5H17.5" stroke="#15351A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
							<path d="M13.3346 8.33203C13.3346 9.21609 12.9834 10.0639 12.3583 10.6891C11.7332 11.3142 10.8854 11.6654 10.0013 11.6654C9.11725 11.6654 8.2694 11.3142 7.64428 10.6891C7.01916 10.0639 6.66797 9.21609 6.66797 8.33203" stroke="#15351A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
						<div class="absolute -right-[22px] -top-[22px] rounded-full bg-bgMain p-1">
							<div class="flex h-2 w-2 items-center justify-center rounded-full bg-primary p-3 text-bgMain">
								{{ store.cart?.totalQuantity ?? 0 }}
							</div>
						</div>
					</div>
					<i class="fa-solid fa-bars text-[20px]" @click="toggle('header')" />
				</div>
			</div>

			<div :class="[global.modal?.name === 'header' && 'right-[0]', 'fixed right-[-100vw] top-[65px] isolate flex h-[calc(100dvh-3.5rem)] w-[60%] flex-col items-center gap-4 overflow-y-auto bg-bgMain px-4 py-[2rem] transition-all duration-500 lg:hidden']">
				<div class="flex w-full flex-col items-center gap-2">
					<router-link v-for="link of links" @click="toggle('header')" class="tab relative pb-2 font-bold capitalize hover:cursor-pointer" :to="link.to">
						{{ link.label }}
					</router-link>
				</div>
				<div class="flex-1" />

				<Button class="w-full" :to="{ name: 'store-locator' }" label="My Account" />
				<Button class="primary w-full" :to="{ name: 'store-locator' }" label="Product Locator" @click="toggle('header')" />
			</div>
		</div>
	</header>
	<div class="h-[100px]"></div>
</template>

<style scoped>
.tab:after {
	@apply absolute bottom-0 left-0 h-1 w-0 bg-primary transition-all duration-500 ease-in content-[''];
}

.tab:hover:after {
	@apply w-full;
}
</style>
